import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/utils/cn';

export type ActionMenuIconValue = LucideIcon | React.ReactNode | string;

export function ActionMenuIcon({ icon, className }: { icon?: ActionMenuIconValue; className?: string }) {
  if (!icon) return null;

  if (typeof icon === 'string') {
    return <i className={cn(icon, className)} />;
  }

  if (React.isValidElement(icon)) {
    return icon;
  }

  const Icon = icon as LucideIcon;
  return <Icon className={className} />;
}
